import React from "react";
import useLicenseCheck from "license/useLicenseCheck";
import Icon from "components/common/Icon";
import Widget from "views/logic/widgets/Widget";
import usePermissions from "hooks/usePermissions";
import InvestigationsVisualization from "./InvestigationsVisualization";
import InvestigationsWidgetEdit from "./InvestigationsWidgetEdit/InvestigationsWidgetEdit";
import InvestigationsWidget from "./logic/InvestigationsWidget";
import { PAGINATION } from "./Constants";
import AddInvestigationsWidgetActionHandler, {
  CreateInvestigationsWidget
} from "./logic/AddInvestigationsWidgetActionHandler";
import InvestigationsListConfigGenerator from "./logic/searchtypes/InvestigationsListConfigGenerator";
import InvestigationsListHandler from "./logic/searchtypes/InvestigationsListHandler";
Widget.registerSubtype(InvestigationsWidget.type, InvestigationsWidget);
const investigationsSearchWidgets = {
  enterpriseWidgets: [
    {
      type: "INVESTIGATIONS",
      displayName: "Investigations",
      defaultHeight: 4,
      defaultWidth: 6,
      hasEditSubmitButton: true,
      visualizationComponent: InvestigationsVisualization,
      editComponent: InvestigationsWidgetEdit,
      searchTypes: InvestigationsListConfigGenerator,
      titleGenerator: () => InvestigationsWidget.defaultTitle,
      needsControlledHeight: () => false,
      searchResultTransformer: (data) => data == null ? void 0 : data[0]
    }
  ],
  widgetCreators: [
    {
      title: "Investigations Overview",
      func: CreateInvestigationsWidget,
      icon: () => /* @__PURE__ */ React.createElement(Icon, { name: "extension" })
    }
  ],
  creators: [
    {
      type: "investigations",
      title: "Investigations Overview",
      func: AddInvestigationsWidgetActionHandler,
      useCondition: () => {
        const { security } = useLicenseCheck();
        const { isPermitted } = usePermissions();
        return (security == null ? void 0 : security.isValid) && isPermitted(["investigations:read"]);
      }
    }
  ],
  searchTypes: [
    {
      type: InvestigationsWidget.type,
      handler: InvestigationsListHandler,
      defaults: {
        page: PAGINATION.INITIAL_PAGE,
        per_page: PAGINATION.PER_PAGE
      }
    }
  ]
};
export default investigationsSearchWidgets;
